module.exports = __webpack_public_path__ + "img/chinesecompany87.3ce2e164.png";